import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Legend
} from "recharts";
const COLORS = [
  "#28a745",
  "#17a2b8",
  "#ffc107"
];
function formatDate(dateStr) {
  if (!dateStr) return "-";
  const str = String(dateStr);
  const [date] = str.split(" ");
  const parts = date.split("-");
  if (parts.length !== 3) return str;
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
}
function formatCurrency(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
const VendorNameTick = ({ x, y, payload }) => {
  const name = payload.value || "";

  const words = name.split(" ");

  // Split into approximately two lines
  const middle = Math.ceil(words.length / 2);

  const line1 = words.slice(0, middle).join(" ");
  const line2 = words.slice(middle).join(" ");

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        textAnchor="middle"
        fill="#666"
        fontSize={12}
      >
        <tspan x="0" dy="15">
          {line1}
        </tspan>

        {line2 && (
          <tspan x="0" dy="15">
            {line2}
          </tspan>
        )}
      </text>
    </g>
  );
};
class VendorReportComponent extends React.Component {
  render() {
    return (
      <div className="container-fluid">
        {/* =======================================
                Summary Cards
        ======================================== */}
        <div className="row mb-3">
          <div className="col-md-2">
            <div className="card text-center">
              <div className="card-body">
                <h6>Total Vendors</h6>
                <h3>
                  <div style={{ whiteSpace: "nowrap" }}>
                    {this.props.totalVendors}
                  </div>
                </h3>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-center">
              <div className="card-body">
                <h6>Total Invoice</h6>
                <h3>
                  <div style={{ whiteSpace: "nowrap" }}>
                    ₹ {formatCurrency(this.props.totalInvoiceAmount)}
                  </div>
                </h3>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-center">
              <div className="card-body">
                <h6>Total Paid</h6>
                <h3>
                  <div style={{ whiteSpace: "nowrap" }}>
                    ₹ {formatCurrency(this.props.totalPaidAmount)}
                  </div>
                </h3>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <h6>Outstanding Balance</h6>
                <h3>
                  <div style={{ whiteSpace: "nowrap" }}>
                    ₹ {formatCurrency(this.props.totalOutstandingBalance)}
                  </div>
                </h3>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <button
                  type="button"
                  className={
                    this.props.showPendingPayments
                      ? "btn btn-warning btn-block"
                      : "btn btn-danger btn-block"
                  }
                  onClick={this.props.onPendingPaymentsClick}
                >
                  <div style={{ fontWeight: "bold" }}>
                    Pending Payments
                  </div>

                  <div
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: "bold"
                    }}
                  >
                    {this.props.totalPendingInvoices}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* =======================================
                Header
        ======================================== */}
        <div className="card">
          <div className="card-header">
            <div className="row">
              {/* ==========================
                      LEFT SIDE
              ========================== */}
              <div className="col-md-4">
                {/* Vendor */}
                <div className="form-group">
                  <label><b>Select Vendor</b></label>
                  <select
                    className="form-control"
                    value={this.props.selectedVendor}
                    onChange={this.props.onVendorChange}
                  >
                    <option value="">Select Vendor</option>
                    {(this.props.vendors || [])
                      .map((vendor) => (
                        <option
                          key={vendor.id}
                          value={vendor.id}
                        >
                          {vendor.vendor_name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="mt-3">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={this.props.refreshData}
                    disabled={this.props.loading}
                  >
                    {this.props.loading ? "Refreshing..." : "Refresh"}
                  </button>
                  <button
                    className="btn btn-warning mr-2"
                    onClick={this.props.resetFilters}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={this.props.onExport}
                  >
                    Export Excel
                  </button>
                </div>
              </div>

              {/* ==========================
                      RIGHT SIDE
              ========================== */}

              <div className="col-md-8">
                <label><b>Date Range</b></label>
                <div className="row">
                  <div className="col-md-5">
                    <input
                      type="date"
                      className="form-control"
                      value={this.props.fromDate}
                      onChange={this.props.onFromDateChange}
                    />
                  </div>
                  <div className="col-md-5">
                    <input
                      type="date"
                      className="form-control"
                      value={this.props.toDate}
                      onChange={this.props.onToDateChange}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    className="btn btn-info mr-2"
                    onClick={this.props.applyDateFilter}
                  >
                    Apply Date Filter
                  </button>
                  <button
                    className="btn btn-outline-info"
                    onClick={this.props.clearDateFilter}
                  >
                    Clear Dates
                  </button>
                </div>
              </div>
            </div>
            <hr />

            {/* ==========================
                    QUICK FILTERS
            ========================== */}

            <div className="row text-center">
              <div className="col-md-3">
                <button
                  className={
                    this.props.activePeriod === "today"
                      ? "btn btn-info btn-lg btn-block"
                      : "btn btn-outline-info btn-lg btn-block"
                  }
                  onClick={() => this.props.changePeriod("today")}
                >
                  <h5>Today</h5>
                  <h3>({this.props.todaySummary.invoiceCount})</h3>
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className={
                    this.props.activePeriod === "yesterday"
                      ? "btn btn-info btn-lg btn-block"
                      : "btn btn-outline-info btn-lg btn-block"
                  }
                  onClick={() => this.props.changePeriod("yesterday")}
                >
                  <h5>Yesterday</h5>
                  <h3>({this.props.yesterdaySummary.invoiceCount})</h3>
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className={
                    this.props.activePeriod === "lastweek"
                      ? "btn btn-info btn-lg btn-block"
                      : "btn btn-outline-info btn-lg btn-block"
                  }
                  onClick={() => this.props.changePeriod("lastweek")}
                >
                  <h5>Last Week</h5>
                  <h3>({this.props.lastWeekSummary.invoiceCount})</h3>
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className={
                    this.props.activePeriod === "lastmonth"
                      ? "btn btn-info btn-lg btn-block"
                      : "btn btn-outline-info btn-lg btn-block"
                  }
                  onClick={() => this.props.changePeriod("lastmonth")}
                >
                  <h5>Last Month</h5>
                  <h3>({this.props.lastMonthSummary.invoiceCount})</h3>
                </button>
              </div>

            </div>

          </div>
        </div>
        {/* =======================================
            Paid vs Pending Payments
        ======================================= */}
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  Total vs Paid Payments
                </h5>
                <div className="d-flex align-items-center">
                  <label className="mb-0 mr-2">
                    Year:
                  </label>
                  <select
                    className="form-control"
                    value={this.props.paymentComparisonYear}
                    onChange={this.props.onPaymentComparisonYearChange}
                  >
                    {this.props.yearList.map(year => (
                      <option
                        key={year}
                        value={year}
                      >
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="card-body">
                {!this.props.selectedVendor ? (
                  <div className="text-center text-muted py-5">
                    Please select a vendor to view
                    payment details.
                  </div>
                ) : (
                  <ResponsiveContainer
                    width="100%"
                    height={350}
                  >
                    <BarChart
                      data={
                        this.props
                          .paymentComparisonChartData || []
                      }
                      margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5
                      }}
                    >
                      <CartesianGrid
                        strokeDasharray="3 3"
                      />
                      <XAxis
                        dataKey="month"
                      />
                      <YAxis
                        tickFormatter={(value) =>
                          `₹${(
                            value / 1000
                          ).toFixed(0)}K`
                        }
                      />
                      <Tooltip
                        formatter={(value, name) => [
                          `₹ ${formatCurrency(value)}`,
                          name
                        ]}
                      />
                      <Legend />
                      <Bar
                        dataKey="totalAmount"
                        name="Total Amount"
                        fill="#17a2b8"
                      />
                      <Bar
                        dataKey="paidAmount"
                        name="Paid Amount"
                        fill="#28a745"
                      />
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* =======================================
            Vendor-wise + Month-wise
            Total Amount vs Paid Amount
        ======================================= */}
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card">
              {/* ================================
                    HEADER
              ================================= */}
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">
                    Vendor-wise + Month-wise Total vs Paid Amount
                  </h5>
                  <div className="d-flex align-items-center">
                    {/* YEAR */}
                    <label className="mb-0 mr-2">
                      Year:
                    </label>
                    <select
                      className="form-control mr-3"
                      value={
                        this.props.vendorMonthYear
                      }
                      onChange={
                        this.props.onVendorMonthYearChange
                      }
                      style={{
                        width: "120px"
                      }}
                    >
                      {
                        this.props.yearList.map(
                          year => (
                            <option
                              key={year}
                              value={year}
                            >
                              {year}
                            </option>
                          )
                        )
                      }
                    </select>
                    {/* MONTH */}
                    <label className="mb-0 mr-2">
                      Month:
                    </label>
                    <select
                      className="form-control"
                      value={
                        this.props.vendorMonth
                      }
                      onChange={
                        this.props.onVendorMonthChange
                      }
                      style={{
                        width: "140px"
                      }}
                    >
                      <option value="all">
                        All Months
                      </option>
                      <option value="0">
                        January
                      </option>
                      <option value="1">
                        February
                      </option>
                      <option value="2">
                        March
                      </option>
                      <option value="3">
                        April
                      </option>
                      <option value="4">
                        May
                      </option>
                      <option value="5">
                        June
                      </option>
                      <option value="6">
                        July
                      </option>
                      <option value="7">
                        August
                      </option>
                      <option value="8">
                        September
                      </option>
                      <option value="9">
                        October
                      </option>
                      <option value="10">
                        November
                      </option>
                      <option value="11">
                        December
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              {/* ================================
                    CHART
              ================================= */}
              <div className="card-body">
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden"
                  }}
                >
                  <div
                    style={{
                      width: Math.max(
                        800,
                        (this.props.vendorMonthChartData || []).length * 150
                      ),
                      height: 400
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={this.props.vendorMonthChartData || []}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 60,
                          bottom: 60
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />

                        <XAxis
                          dataKey="vendor"
                          interval={0}
                          height={70}
                          tick={<VendorNameTick />}
                        />

                        <YAxis />

                        <Tooltip />

                        <Legend />

                        <Bar
                          dataKey="totalAmount"
                          name="Total Amount"
                          fill="#17a2b8"
                        />

                        <Bar
                          dataKey="paidAmount"
                          name="Paid Amount"
                          fill="#28a745"
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table className="table table-bordered table-hover text-center">
          {this.props.showPendingPayments ? (
            /* =======================================
               PENDING PAYMENTS TABLE
            ======================================== */
            <>
              <thead className="thead-light">
                <tr>
                  <th>S.No</th>
                  <th>Vendor Name</th>
                  <th>Invoice Date</th>
                  <th>Invoice Amount</th>
                  <th>Paid Amount</th>
                  <th>Pending Amount</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>

                {this.props.pendingPaymentsTable &&
                  this.props.pendingPaymentsTable.length > 0 ? (

                  this.props.pendingPaymentsTable.map(
                    (item, index) => (
                      <tr key={item.invoice_id}>

                        <td>
                          {index + 1}
                        </td>

                        <td>
                          {item.vendor_name}
                        </td>

                        <td>
                          {formatDate(
                            item.invoice_date
                          )}
                        </td>

                        <td>
                          ₹{" "}
                          {formatCurrency(
                            item.invoice_amount
                          )}
                        </td>

                        <td>
                          ₹{" "}
                          {formatCurrency(
                            item.paid_amount
                          )}
                        </td>

                        <td
                          style={{
                            fontWeight: "bold",
                            color: "#d39e00"
                          }}
                        >
                          ₹{" "}
                          {formatCurrency(
                            item.pending_amount
                          )}
                        </td>
                        <td>
                          {item.status === "PARTIAL" ? (
                            <span className="badge badge-info">
                              PARTIAL
                            </span>
                          ) : item.status === "NOT PAID" ? (
                            <span className="badge badge-warning">
                              NOT PAID
                            </span>
                          ) : item.status === "PAID" ? (
                            <span className="badge badge-success">
                              PAID
                            </span>
                          ) : (
                            <span className="badge badge-secondary">
                              -
                            </span>
                          )}
                        </td>
                      </tr>
                    )
                  )

                ) : (

                  <tr>
                    <td
                      colSpan="7"
                      className="text-center"
                    >
                      No Pending Payments Found
                    </td>
                  </tr>

                )}

              </tbody>

              {/* Pending Payments Total */}
              {this.props.pendingPaymentsTable &&
                this.props.pendingPaymentsTable.length > 0 && (

                  <tfoot>

                    <tr
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#f8f9fa"
                      }}
                    >

                      <td colSpan="5">
                        TOTAL PENDING
                      </td>

                      <td>
                        ₹{" "}
                        {formatCurrency(
                          this.props.pendingPaymentsTable.reduce(
                            (total, item) =>
                              total +
                              Number(
                                item.pending_amount || 0
                              ),
                            0
                          )
                        )}
                      </td>

                      <td>
                        {
                          this.props.pendingPaymentsTable.length
                        }{" "}
                        Invoice(s)
                      </td>
                    </tr>
                  </tfoot>
                )}
            </>
          ) : (
            /* =======================================
               NORMAL VENDOR REPORT TABLE
            ======================================== */
            <>
              <thead className="thead-light">
                <tr>
                  <th>S.No</th>
                  <th>Vendor Name</th>
                  <th>Phone Number</th>
                  <th>Invoice Count</th>
                  <th>Total Invoice Amount</th>
                  <th>Total Paid Amount</th>
                  <th>Outstanding Balance</th>
                  <th>Pending Invoices</th>
                  <th>Last Invoice Date</th>
                  <th>Last Payment Date</th>
                  <th>Payment Status</th>
                </tr>
              </thead>
              <tbody>
                {this.props.vendorReport &&
                  this.props.vendorReport.length > 0 ? (
                  this.props.vendorReport.map(
                    (vendor, index) => (
                      <tr key={vendor.vendor_id}>
                        <td>
                          {index + 1}
                        </td>
                        <td>
                          {vendor.vendor_name}
                        </td>
                        <td>
                          {vendor.phone_number || "-"}
                        </td>
                        <td>
                          {vendor.invoice_count}
                        </td>
                        <td>
                          ₹{" "}
                          {formatCurrency(
                            vendor.total_invoice_amount
                          )}
                        </td>
                        <td>
                          ₹{" "}
                          {formatCurrency(
                            vendor.total_paid_amount
                          )}
                        </td>
                        <td>
                          ₹{" "}
                          {formatCurrency(
                            vendor.outstanding_balance
                          )}
                        </td>
                        <td>
                          {vendor.pending_invoices}
                        </td>
                        <td>
                          {formatDate(
                            vendor.last_invoice_date
                          )}
                        </td>
                        <td>
                          {formatDate(
                            vendor.last_payment_date
                          )}
                        </td>
                        <td>
                          {vendor.payment_status ===
                            "PAID" ? (
                            <span className="badge badge-success">
                              PAID
                            </span>
                          ) : vendor.payment_status ===
                            "PARTIAL" ? (
                            <span className="badge badge-info">
                              PARTIAL
                            </span>
                          ) : vendor.payment_status ===
                            "NOTPAID" ? (
                            <span className="badge badge-warning">
                              NOT PAID
                            </span>
                          ) : (
                            <span className="badge badge-secondary">
                              -
                            </span>
                          )}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="11"
                      className="text-center"
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
              {/* Normal Vendor Report Totals */}
              {this.props.vendorReport &&
                this.props.vendorReport.length > 0 && (
                  <tfoot>
                    <tr
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#f8f9fa"
                      }}
                    >
                      <td colSpan="4">
                        TOTAL
                      </td>
                      <td>
                        ₹{" "}
                        {formatCurrency(
                          this.props.totalInvoiceAmount
                        )}
                      </td>
                      <td>
                        ₹{" "}
                        {formatCurrency(
                          this.props.totalPaidAmount
                        )}
                      </td>
                      <td>
                        ₹{" "}
                        {formatCurrency(
                          this.props.totalOutstandingBalance
                        )}
                      </td>
                      <td>
                        {this.props.totalPendingInvoices}
                      </td>
                      <td>
                        -
                      </td>
                      <td>
                        -
                      </td>
                      <td>
                        {this.props.totalVendors}{" "}
                        Vendor(s)
                      </td>
                    </tr>
                  </tfoot>
                )}
            </>
          )}
        </table>
      </div>
    );
  }
}
export default VendorReportComponent;